<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange">
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'userIndex',
    data () {
      return {
        menuid: 12,
        com: this.$route.params.form,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'usercode', fieldtype: 'C', title: '账号',calculExpr:'', addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '姓名',calculExpr:'',addNewRowFlg: false},
          { field: 'dptname', fieldtype: 'C', title: '部门',calculExpr:'',addNewRowFlg: false},
          { field: 'usertel', fieldtype: 'C',title: '电话',calculExpr:'',addNewRowFlg: false},
          { field: 'usermobile', fieldtype: 'C',title: '手机',calculExpr:'',addNewRowFlg: false},
          { field: 'userremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        user: {},
        query: {
          comid: this.$route.params.form.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addUser())
      this.$on('CHG', () => this.chgUser())
      this.$on('DEL', () => this.delUser())
      this.$on('RESET', () => this.resetPassword())
      this.$on('AUTH', () => this.authRole())
      this.$on('CLOSE', () => this.close())
    },
    async activated() {
      await this.init()
      await this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async init() {
        this.com = this.$route.params.form
        this.list = []
        this.user = {}
        this.query = {
          comid: this.$route.params.form.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
      },
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        if (this.com) {
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'comIndex'})
        } else {
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
        }
      },
      async addUser () {
        let form = {
          userid: 0,
          usercomid: this.$route.params.form.comid,
          comtype:this.$store.getters.loginUser.comtype,
          userstatus: '1',
          userlockflg: '1'
        }
        this.$router.push({name: 'userForm', params: {form: form, type: 1}})
      },
      async chgUser () {
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        this.$router.push({name: 'userForm', params: {form: this.user, type: 2}})
      },
      async authRole () {
        if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
        }
        this.$router.push({name: 'userRoleForm', params: {form: this.user}})
      },
      async delUser () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/user/delUser',
            method: "post",
            data: this.user
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      async resetPassword () {
        this.$confirm('确定重置密码?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/user/resetPassword',
            method: "post",
            data: this.user
          })
          if (data.issuccess===1) {
            this.$message.success('重置密码成功,重置后密码为:888888')
          } else {
            this.$message.error('重置密码失败！')
          }
        })
      },
      handleSizeChange (btnPage) {
        this.query.offset = btnPage.pageSize * (btnPage.currentPage - 1)
        this.query.limit = btnPage.pageSize
        this.getPageList()
      },
      handleCurrentChange (btnPage) {
        this.query.offset = btnPage.pageSize * (btnPage.currentPage - 1)
        this.query.limit = btnPage.pageSize
        this.getPageList()
      },
      search (target) {},
      async save () {
        await request({
          url: '/xtgl/user/addOrEdit',
          method: "post",
          data: this.user
        })
        this.$message.success('操作成功')
        if (!this.user.userid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.user = row.row
      },
      async pagechange (userPage) {
        this.query.offset = userPage.pageSize * (userPage.currentPage - 1)
        this.query.limit = userPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getPageList',
          params: this.query
        })
        console.log(res)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
